














import { defineComponent, computed } from '@vue/composition-api';
import { Field } from '@hb/finance-ui';

export default defineComponent({
  name: 'FormItem',
  components: {
    Field,
  },
  props: {
    fieldProps: {
      type: Object,
      default: {
        attrs: {},
        on: {},
      },
    },
  },
  setup(props) {
    const fieldProps = computed(() => props.fieldProps);
    const isUserName = computed(() => props.fieldProps.attrs.name === 'userName');
    const isPeriodBegin = computed(() => props.fieldProps.attrs.name === 'periodBegin');
    return {
      fieldProps,
      isUserName,
      isPeriodBegin,
    };
  },
});
